<div class="container" [formGroup]="formGroup">
  <pdq-card variant="popover" color="white">
    <div class="card-content">
      <div class="section-header">
        <pdq-heading element="h6">Pricing model</pdq-heading>
        <span class="section-subtitle">Sets the protection rate charged.</span>
      </div>
      <pdq-divider></pdq-divider>
      <div>
        <div class="pricing-fields">
          <div class="pricing-field">
            <span class="field-label">Pricing Type</span>
            <pdq-dropdown
              type="input"
              fullWidth="true"
              [options]="pricingTypeOptions"
              [defaultOption]="selectedPricingTypeOption"
              (onChange)="onPricingTypeChange($event)"></pdq-dropdown>
          </div>
          <div class="pricing-field">
            <span class="field-label">{{ rateLabel }}</span>
            <pdq-input-arrows
              formControlName="rate"
              [symbol]="rateSymbol"
              [min]="rateMin"
              [max]="rateMax"
              [step]="rateStep"
              [precision]="ratePrecision"
              widthSize="fullwidth"></pdq-input-arrows>
            @if (rateHint) {
              <span class="field-hint">{{ rateHint }}</span>
            }
          </div>
        </div>
        <pdq-banner
          variant="info"
          bannerTitle="Pricing at checkout"
          content="The fee is rounded down to the nearest available protection tier."
          [closable]="false"></pdq-banner>
      </div>
    </div>
  </pdq-card>
</div>
